import type { Renderer, Texture } from '@pixi/core';
import type { IPoint } from '@pixi/math';
import { Mesh } from '@pixi/mesh';

import { TrailGeometry, TrailGeometrySettings } from './TrailGeometry';
import { TrailMaterial } from './TrailMaterial';

export class TrailDisplay extends Mesh
{
    public autoUpdate: boolean;

    constructor(texture: Texture, points: IPoint[], alphas: number[], settings: Partial<TrailGeometrySettings> = {})
    {
        const geometry = new TrailGeometry(points, alphas, settings);
        const meshMaterial = new TrailMaterial(texture);

        super(geometry, meshMaterial as any);
        this.autoUpdate = true;
        geometry.update();
    }

    get offset(): number
    {
        return (this.material as any as TrailMaterial).offset;
    }

    set offset(v: number)
    {
        (this.material as any as TrailMaterial).offset = v;
    }

    public get points(): IPoint[]
    {
        return (this.geometry as TrailGeometry).points;
    }

    public get alphas(): number[]
    {
        return (this.geometry as TrailGeometry).alphas;
    }

    public get thickness(): number
    {
        return (this.geometry as TrailGeometry).settings.thickness;
    }

    public set thickness(v: number)
    {
        const geom = this.geometry as TrailGeometry;

        if (v !== geom.settings.thickness)
        {
            geom.settings.thickness = v;
        }
    }

    public get width(): number
    {
        return (this.geometry as TrailGeometry).settings.width;
    }

    public set width(v: number)
    {
        const geom = this.geometry as TrailGeometry;

        if (v !== geom.settings.width)
        {
            geom.settings.width = v;
        }
    }

    public updateTrail(): void
    {
        const geom = this.geometry as TrailGeometry;

        geom.update();
    }

    _render(renderer: Renderer): void
    {
        if (this.autoUpdate) this.updateTrail();

        super._render(renderer);
    }
}
